import React from 'react';
import classNames from 'classnames';

import { Container, Nav, NavDropdown, Navbar } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import Link from 'ui-kit/link/link';

import logo from 'assets/images/logo.jpg';

const DesktopMenu = ({ className, token }) => {
    const classes = classNames('desktop-menu', className);

    return (
        <Container className={classes} fluid>
            <Navbar.Brand>
                <Link
                    to="/"
                    img={<img src={logo} alt="Muncie Land Bank" className="logo" />}
                    label="Muncie Land Bank"
                />
            </Navbar.Brand>
            <Nav className="d-flex align-items-center">
                <Link className="nav-link" to="/" label="Home" />
                <NavDropdown title="About" id="about-nav-dropdown">
                    <LinkContainer to="/about/board-of-directors">
                        <Nav.Link>Board of Directors</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/about/board-meetings">
                        <Nav.Link>Board Meetings</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/about/policy-and-procedures">
                        <Nav.Link>Policy &amp; Procedures</Nav.Link>
                    </LinkContainer>
                    <NavDropdown.Divider />
                    <LinkContainer to="/about/history">
                        <Nav.Link>History</Nav.Link>
                    </LinkContainer>
                </NavDropdown>
                <NavDropdown title="Resources" id="resources-nav-dropdown">
                    <LinkContainer to="/resources/building-blocks">
                        <Nav.Link>Building Blocks</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/resources/press-releases">
                        <Nav.Link>Press Releases</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/resources/reports">
                        <Nav.Link>Reports</Nav.Link>
                    </LinkContainer>
                </NavDropdown>
                {!token && <Link to="/account" label="Sign In" />}
                {token && (
                    <NavDropdown title="Admin" id="resources-nav-dropdown" alignRight>
                        <LinkContainer to="/admin/properties/add">
                            <Nav.Link>Add Property</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/admin/properties">
                            <Nav.Link>View Properties</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/admin/bids">
                            <Nav.Link>Bids</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/account/logout">
                            <Nav.Link>Logout</Nav.Link>
                        </LinkContainer>
                    </NavDropdown>
                )}
                <Link to="/properties" label="Properties" variant="button" />
            </Nav>
        </Container>
    );
};

export default DesktopMenu;
